import { fetchAndParse } from '../../ts/utils/ajax';
import type { ItemCollectionResponse } from '../types/api';
import type { ServiceInvokerRequestAPI } from '../types/service';
import { getTenantId } from '../utils/tenant';

// Fetching all the service invoker requests for a given state ID
export const getServiceInvokerRequestsByState = ({
    stateId,
    page = 1,
    pageSize = 1000,
}: {
    stateId: string;
    page: number;
    pageSize: number;
}) =>
    fetchAndParse<ItemCollectionResponse<ServiceInvokerRequestAPI>>({
        url: `/api/service/1/requests/state/${stateId}?page=${page}&pageSize=${pageSize}`,
        method: 'GET',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });

// Fetch the given service invoker request by ID
export const getServiceInvokerRequest = ({ requestId }: { requestId: string }) =>
    fetchAndParse<ServiceInvokerRequestAPI>({
        url: `/api/service/1/requests/${requestId}`,
        method: 'GET',
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });
